import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=a3190662&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=a3190662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3190662",
  null
  
)

export default component.exports